import { render, staticRenderFns } from "./matrix.vue?vue&type=template&id=346878f6&lang=pug"
import script from "./matrix.vue?vue&type=script&lang=js"
export * from "./matrix.vue?vue&type=script&lang=js"
import style0 from "./matrix.vue?vue&type=style&index=0&id=346878f6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports